import { render, staticRenderFns } from "./SalesOrdersShortcutCard.vue?vue&type=template&id=3c84da9c&scoped=true&"
import script from "./SalesOrdersShortcutCard.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersShortcutCard.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrdersShortcutCard.vue?vue&type=style&index=0&id=3c84da9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c84da9c",
  null
  
)

export default component.exports